import type {
  PricingCategories,
  PricingCategoriesApi,
  PricingCategory,
  PricingCategoryApi,
  PricingCategoryFilters,
  PricingCategoryFiltersUpdateApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizePricingCategory = (pricingCategory: PricingCategoryApi): PricingCategory => ({
  ...pricingCategory,
  id: pricingCategory.codeId ?? String(pricingCategory.id),
  label: pricingCategory.codeDesc,
});

export const normalizePricingCategories = (response: PricingCategoriesApi): PricingCategories => {
  const list = (response.items ?? [])
    .sort((a, b) => a.codeDesc.localeCompare(b.codeDesc))
    .map(normalizePricingCategory);

  return {
    list,
    map: list.reduce(
      (acc, pricingCategory) => {
        acc[String(pricingCategory.id)] = pricingCategory;
        return acc;
      },
      {} as PricingCategories['map'],
    ),
  };
};

export const normalizePricingCategoryFilters = (
  filters: Partial<PricingCategoryFilters>,
): PricingCategoryFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
